import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import * as getters from './getters'
import { setCookie } from 'tiny-cookie'
import { generateMenu } from '../js/menu.js'
Vue.use(Vuex)

const getDefaultState = () => {
  return {
    settings: {
      username: '',
      user: {
        customer_type:'',
      },
      menus: [],
      isIniting: true,
      usertype: 3,
      role: '',
      permList: [],
      integration: 6,// Integration => Interactive ads
    },
    timezone: [],
    country: [],
    offer_setting: {},
    tip_show: false,
    channel_list: [],
    channel: {},
    aid: '',
    default_sml: [
      '200580',
      // '32017',
      '32013',
      '31537',
      '213492',
      '213476',
      '213460',
      '213508',
      '213524',
      // '204708',
      // '207684',
      '214340',
      '214324',
      '217012',
    ],
    active_menu: '',
    place_type_list: [
      {
        // 广告位类型
        id: 1,
        key: 'top',
        name: 'Top-Floating Banner',
        select: 0,
      },
      {
        id: 2,
        key: 'bottom',
        name: 'Bottom-Floating Banner',
        select: 0,
      },
      {
        id: 3,
        key: 'center',
        name: 'Pop-up Banner',
        select: 0,
      },
      {
        id: 4,
        key: 'inner',
        name: 'Inner Banner',
        select: 0,
      },
    ],
    menus2:[]
  }
}
// 应用初始状态
const state = getDefaultState()

// 定义所需的 mutations
const mutations = {
  SETTINGS(state, res) {
    if (res.c === -3) {
      this._vm.Logout()
    } else {
      setCookie('login', true)
      // this._vm.$account._s(data.a);
      let settings = state.settings
      let data = res.a
      settings.menus = generateMenu(data.m.en)
      settings.permList = data.m.en
      settings.user = data.p
      settings.usertype = data.a
      settings.jsca = data.jsca
      if (settings && !settings.menus.length) {
        settings.menus = data ? generateMenu(data.m.en) : []
        settings.permList = data ? data.m.en : []
        settings.username = data ? data.p.un : ''
        settings.user = data ? data.p : {}
        settings.usertype = data ? data.a : ''
        settings.jsca = data ? data.jsca : false
      }
    }
  },
  RESET(state) {
    Object.assign(state, getDefaultState())
  },
  CHANNEL_LIST(state, data) {
    state.channel_list = data
    // if(state.settings.user.customer_type === 13){
    //   state.aid = data[1].id
    //   state.channel = data[1]
    // }else{
    //   state.aid = data[0].id
    //   state.channel = data[0]
    // }
    state.aid = data[0].id
    state.channel = data[0]
  },
  AID(state, data) {
    state.aid = data
  },
  CHANNEL(state, data) {
    state.channel = data
  },
  TIMEZONE(state, data) {
    state.timezone = data
  },
  COUNTRY(state, data) {
    state.country = data
  },
  OFFER_SETTING(state, data) {
    state.offer_setting = data
  },
  TIP_SHOW(state, data) {
    state.tip_show = data
  },
  ACTIVE_MENU(state, data) {
    state.active_menu = data
  },
}

// 创建 store 实例
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations,
})
